<template>
  <v-layout row justify-center>
    <v-dialog v-model="showCreateDialog" persistent max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="#4cc0ad" class="white--text" icon v-on="on">
            <v-icon>add</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Add Breakout</span>
        </v-card-title>
        <v-card-text>
            <!-- Success Message -->
            <v-alert :value="breakoutCreateForm.successful" type="success">
                Media created!
            </v-alert>

            <v-form ref="form" role="form" @submit.prevent="saveBreakout">
            <!-- Name -->
  
                <v-text-field outline label="Title *" name="title" v-model="breakoutCreateForm.title" :class="{'is-invalid': breakoutCreateForm.errors.has('title')}"></v-text-field>

                <span class="invalid-feedback" v-show="breakoutCreateForm.errors.has('title')">
                    @{{ breakoutCreateForm.errors.get('title') }}
                </span>
    

    
                <v-textarea outline label="Description" name="description" v-model="breakoutCreateForm.description" :class="{'is-invalid': breakoutCreateForm.errors.has('description')}" rows="4"></v-textarea>

                <span class="invalid-feedback" v-show="breakoutCreateForm.errors.has('description')">
                    @{{ breakoutCreateForm.errors.get('description') }}
                </span>
            

 
                <v-text-field outline label="Vimeo ID*" name="source_id" v-model="breakoutCreateForm.source_id" :class="{'is-invalid': breakoutCreateForm.errors.has('source_id')}"></v-text-field>

                <span class="invalid-feedback" v-show="breakoutCreateForm.errors.has('source_id')">
                    @{{ breakoutCreateForm.errors.get('source_id') }}
                </span>
               
                

        
                <v-text-field outline label="Image Source (Thumbnail URL)" name="image_src" v-model="breakoutCreateForm.image_src" :class="{'is-invalid': breakoutCreateForm.errors.has('image_src')}"></v-text-field>

                <span class="invalid-feedback" v-show="breakoutCreateForm.errors.has('image_src')">
                    @{{ breakoutCreateForm.errors.get('image_src') }}
                </span>
        


            </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="showCreateDialog = false">Close</v-btn>
          <v-btn flat color="primary" type="submit" :disabled="breakoutCreateForm.busy" @click.prevent="saveBreakout">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>


</template>

<script>
 
    var breakoutCreateForm = function () {
        return {
            source_id: '',
            title: '',
            description: '',
            image_src: ''
        };
    };

    export default {
        data(){
            return {
                showCreateDialog : false,
                breakoutCreateForm: new SparkForm(breakoutCreateForm()),
                isUpdating: false
            }
        },
        created(){



        },
        mounted() {
            console.log('media Dialog mounted.')
        },
        methods: {
 

            saveBreakout(){


                /* passed validation, submit */

                this.breakoutCreateForm.errors.forget();

                Spark.post('/api/breakouts', this.breakoutCreateForm)
                .then((response) => {

                    console.log(response);

 
                    Bus.$emit('vmBreakoutsChanged');

                    this.breakoutCreateForm = new SparkForm(breakoutCreateForm());
                    this.showCreateDialog = false;


                    // setTimeout(() => {

                    //     this.showCreateDialog = false;
                    //     this.breakoutCreateForm = new SparkForm(breakoutCreateForm());

                    // }, 1000);


                    //this.formSuccess = true;

                }).catch((error) => {

                    // this.savingEvent = false;
                    // this.formSuccess = false;

                    this.breakoutCreateForm.errors.set(error.errors);

                });


                
            }

        }
    }
</script>


<style scoped>
  

</style>